import { HOME_DELETE_STR } from "common/sf_strings";
import { MODE } from "helpers/sf_constants";
import { optionsGarageType, optionsPropertyType, optionsTrueFalse } from "helpers/sf_lead_constants";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Card, CardBody, Col, Label, Row, Table } from "reactstrap";
import { addLeadHome, deleteLeadHome, updateLeadHome } from "store/leads/lead_homes_actions";
import DeleteModal from "../DeleteModal";
import AddHomeModal from "../Modals/AddHomeModal";
import LeadEditDropdown from "./LeadEditDropdown";
import LeadEditDropdownForNumberFields from "./LeadEditDropdownForNumberFields";
import EditAddressDropdown from "./EditAddressDropdown";
import { getPrimaryTextClass } from "helpers/sf_utils";
import { deleteProspectHome, updateProspectHome } from "store/prospects/prospects_homes_actions";
import { addProspectHome } from "store/prospects/actions";
import LeadDetailReadOnlyContext from "contexts/LeadDetailReadOnlyContext";
import { useContext } from "react";

const LeadHomes = (props) => {
    const isReadOnly = useContext(LeadDetailReadOnlyContext) || props?.isReadOnly;
    const [homeModalState, setHomeModalState] = useState({ active: false });
    const [deleteHomeModal, setdeleteHomeModal] = useState({ action: false, home: {} });
    const [lead_data, setLeadData] = useState({})
    const { lead_id } = useParams();
    const { leads } = useSelector(state => ({
        leads: state.Leads.leads,
    }));
    const dispatch = useDispatch();

    //Create a useeffect and get lead data from redux store from lead_id from useParams
    let homeUpdater = updateLeadHome
    let homeAdder = addLeadHome
    let homeDeleter = deleteLeadHome
    if (props?.is_prospect) {
        homeUpdater = updateProspectHome;
        homeAdder = addProspectHome
        homeDeleter = deleteProspectHome
    }
    useEffect(() => {
        if (props?.lead_data) {
            setLeadData(props?.lead_data);

        }
    }, [leads, lead_id, props?.lead_data])
    const handleLaunchHomeModal = (active, values, mode) => {
        setHomeModalState({ active: active, values: values, mode: mode });
    }

    const onSubmitHomeModalState = (mode, values) => {
        if (mode === MODE.EDIT) {
            dispatch(homeUpdater({ lead_home: values }))
        } else {
            dispatch(homeAdder({ ...values, lead_id }))
        }
        setHomeModalState({ active: false, values: null })
    }

    // For Delete Home Modal
    const launchDeleteHomeModal = (home) => {
        setdeleteHomeModal({ action: true, home: home });
    };

    const onClickHomeDelete = (payload) => {
        dispatch(homeDeleter({ id: payload?.home?.id }));
        setHomeModalState({ action: false, home: {} });
        setdeleteHomeModal({ action: false, home: {} })
    };

    // Save address
    const onSubmitAddress = (values, id) => {
        const data = {
            lead_home: {
                id: id,
                state: values?.state,
                address: values?.address,
                city: values?.city,
                zip: values?.zip
            }
        }
        dispatch(homeUpdater(data));
    }
    return (
        <React.Fragment>
            <DeleteModal
                deleteModalState={deleteHomeModal}
                onDeleteClick={onClickHomeDelete}
                textMessage={HOME_DELETE_STR}
                onCloseClick={() => setHomeModalState({ action: false, home: {} })}
                cancelButton
            />
            <AddHomeModal
                title={"Home"}
                show={homeModalState}
                onSaveHomeClick={onSubmitHomeModalState}
                onCloseClick={() => handleLaunchHomeModal(false)}
            />
            <Card>
                <CardBody className="pt-0">
                    <Row>
                        <div className="px-0">
                            <Table className="mb-0 text-black">
                                {lead_data?.lead_homes?.map((home, idx) =>
                                (
                                    <tbody id='primary_homes'>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <Col className="d-flex align-items-end pt-1 my-2">
                                                    <i className={`me-2 bx fs-24 bx-home ${getPrimaryTextClass()}`} />
                                                    <div className="me-2 fs-15 font-weight-semibold">
                                                        Home #{idx + 1}
                                                    </div>
                                                    {!isReadOnly &&
                                                        <div className="ms-1 fs-13 text-sfblue font-weight-semibold align-self-end">
                                                            <a onClick={() => handleLaunchHomeModal(true, { ...home }, MODE.EDIT)}>
                                                                Edit
                                                            </a>
                                                        </div>
                                                    }
                                                </Col>
                                            </td>
                                            <td></td>
                                            <td style={{ width: '33%' }}>
                                                {!isReadOnly && idx !== 0 &&
                                                    <Col className={`${getPrimaryTextClass()} pt-1 my-2 font-weight-semibold`}>
                                                        <div className="d-flex flex-row-reverse">
                                                            <a
                                                                className={`d-flex ${getPrimaryTextClass()}`}
                                                                onClick={() => launchDeleteHomeModal(home)}
                                                            >
                                                                <i className="mdi mdi-close me-2" />
                                                                Remove
                                                            </a>
                                                        </div>
                                                    </Col>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Address
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <EditAddressDropdown
                                                            Address={home?.address}
                                                            State={home?.state}
                                                            City={home?.city}
                                                            ZipCode={home?.zip}
                                                            onSaveAddressClick={(e) => onSubmitAddress(e, home?.id)}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Residence Type
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            isDropdown={true}
                                                            options={optionsPropertyType}
                                                            title='Residence Type'
                                                            field={home?.residence_type}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = home?.id
                                                                data.residence_type = value
                                                                dispatch(homeUpdater({ lead_home: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Year Built
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdownForNumberFields
                                                            noThousandSeparator={true}
                                                            title='Year Built'
                                                            field={home?.year_built}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = home?.id
                                                                data.year_built = value
                                                                dispatch(homeUpdater({ lead_home: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Area
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdownForNumberFields
                                                            commaFormatter={true}
                                                            title='Area'
                                                            field={home?.sq_ft || '--'}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = home?.id
                                                                data.sq_ft = value
                                                                dispatch(homeUpdater({ lead_home: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Bedroom(s)
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdownForNumberFields
                                                            noThousandSeparator={true}
                                                            title='Bedroom(s)'
                                                            field={home?.num_bedrooms}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = home?.id
                                                                data.num_bedrooms = value
                                                                dispatch(homeUpdater({ lead_home: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Garage
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            isDropdown={true}
                                                            options={optionsGarageType}
                                                            title='Garage'
                                                            field={home?.garage_type}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = home?.id
                                                                data.garage_type = value
                                                                dispatch(homeUpdater({ lead_home: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Stories
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdownForNumberFields
                                                            noThousandSeparator={true}
                                                            title='Stories'
                                                            field={home?.num_stories}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = home?.id
                                                                data.num_stories = value
                                                                dispatch(homeUpdater({ lead_home: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Bathroom(s)
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdownForNumberFields
                                                            noThousandSeparator={true}
                                                            title='Bathroom(s)'
                                                            field={home?.num_bathrooms || '--'}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = home?.id
                                                                data.num_bathrooms = value
                                                                dispatch(homeUpdater({ lead_home: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Flood Zone
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            isDropdown={true}
                                                            isBoolean={true}
                                                            options={optionsTrueFalse}
                                                            title='Flood Zone'
                                                            field={home?.flood_zone}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = home?.id
                                                                data.flood_zone = value
                                                                dispatch(homeUpdater({ lead_home: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Resident(s)
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdownForNumberFields
                                                            title='Resident(s)'
                                                            field={home?.num_residents}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = home?.id
                                                                data.num_residents = value
                                                                dispatch(homeUpdater({ lead_home: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Swimming Pool
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            isDropdown={true}
                                                            isBoolean={true}
                                                            options={optionsTrueFalse}
                                                            title='Swimming Pool'
                                                            field={home?.swimming_pool}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = home?.id
                                                                data.swimming_pool = value
                                                                dispatch(homeUpdater({ lead_home: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                            </td>
                                            <td style={{ width: '33%' }}></td>
                                        </tr>
                                    </tbody>
                                ))}
                            </Table>
                        </div>
                        <div className="text-sfblue font-weight-semibold mt-4">
                            {!isReadOnly && <a onClick={() => handleLaunchHomeModal(true)}>+ Add Home</a>}
                        </div>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default LeadHomes